import FontIcon from 'components/icons/FontIcon';
import TooltipErrorIcon from 'components/v2/icons/TooltipErrorIcon';
import expandIcon from 'images/icons/svg/expand.svg';
import { Button } from 'primereact/button';
import React, { useId } from 'react';
import styled from 'styled-components';
import { HeaderCaptionSemiBold, TitleIconBar } from 'styles/v2/Styles.styled';

import useIsReadOnlyMode from '../hooks/useIsReadOnlyMode';
import { GridButton } from './StyledGrid';
import Tooltip from 'components/controls/Tooltip';

type Props = {
  caption?: string | undefined | React.ReactNode;
  onMaximize?: React.MouseEventHandler<HTMLButtonElement>;
  onAddRow: React.MouseEventHandler<HTMLButtonElement>;
  onDeleteRows: React.MouseEventHandler<HTMLButtonElement>;
  deleteRowsDisabled?: boolean;
  error?: any;
  required?: boolean;
  hasValue?: boolean;
  hideMutationButtons?: boolean;
  disabled?: boolean;
};

const DynamicGridHeader: React.FC<Props> = ({
  caption,
  hasValue,
  onMaximize,
  onAddRow,
  onDeleteRows,
  deleteRowsDisabled,
  error,
  required,
  hideMutationButtons,
  disabled,
}) => {
  const addButtonId = useId();
  const deleteButtonId = useId();
  const isReadOnly = useIsReadOnlyMode() || disabled;

  return (
    <div className="flex flex-wrap align-items-center justify-content-between gap-2">
      <TitleIconBar>
        <HeaderCaptionSemiBold className="white-space-nowrap">{caption}</HeaderCaptionSemiBold>
        {(error || (required && !hasValue)) && <TooltipErrorIcon content={error || 'Required'} />}
      </TitleIconBar>
      <span>
        {!!onMaximize && (
          <>
            <ExpandButton onClick={onMaximize}>
              <img src={expandIcon} alt="expand" style={{ width: 22, height: 22 }} />
              <Tooltip position="title">Expand</Tooltip>
            </ExpandButton>{' '}
          </>
        )}
        {!hideMutationButtons && (
          <>
            <GridButton id={addButtonId} icon="pi pi-plus" onClick={onAddRow} disabled={isReadOnly} />
            <Tooltip targetId={addButtonId} position="title">
              Add
            </Tooltip>{' '}
            <GridButton
              id={deleteButtonId}
              icon={<FontIcon icon="delete" />}
              onClick={onDeleteRows}
              disabled={isReadOnly || deleteRowsDisabled}
            />
            <Tooltip targetId={deleteButtonId} position="title">
              Delete
            </Tooltip>
          </>
        )}
      </span>
    </div>
  );
};

export default DynamicGridHeader;

const ExpandButton = styled(Button)<{ disabled?: boolean }>`
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  border-color: ${(props) => props.theme.colors.primaryGreen} !important;
  background-color: ${(props) => props.theme.colors.primaryGreen} !important;
`;
